




































































import isMobile from 'piramis-js-utils/lib/isMobile'
import { Component, Mixins, Prop } from 'vue-property-decorator'

import WindowResizeMixin from '../../../../logic/helpers/WindowResizeMixin'
import { tgLoginLink } from '../../../../shared/utils/tgLoginHelpers'
import { CompanyProduct, ProductNames } from './types'

@Component({
  data() {
    return {
      isMobile
    }
  }
})
export default class OurProducts extends Mixins<WindowResizeMixin>(WindowResizeMixin) {

  @Prop({ required: false, type: String }) title!:string

  @Prop({ type: Boolean, default: false, required: false }) showIcons!:boolean

  productsModalOpen = false

  get configProductSettings() {
    return this.$store.state.AdminTemplate.applicationConfig.footer?.ourProducts?.settings ?? {}
  }

  get products(): Array<CompanyProduct> {
    return [
      {
        product: ProductNames.CHATKEEPERBOT,
        title: 'ChatKeeperBot',
        description: this.$t('our_products_description_chatkeeperbot').toString(),
        logo: require('../../../../assets/product-logos/chatkeeper-logo.png'),
        link: tgLoginLink('ChatKeeperBot'),
        ...this.configProductSettings?.[ProductNames.CHATKEEPERBOT] ?? {}
      },
      {
        product: ProductNames.PRESSCODEBOT,
        title: 'PressCodeBot',
        description: this.$t('our_products_description_presscodebot').toString(),
        logo: require('../../../../assets/product-logos/presscode-logo.png'),
        link: tgLoginLink('Presscodebot'),
        ...this.configProductSettings?.[ProductNames.PRESSCODEBOT] ?? {}
      },
      {
        product: ProductNames.TGPULSE,
        title: 'TgPulse',
        description: this.$t('our_products_description_tgpulse').toString(),
        logo: require('../../../../assets/product-logos/tg-pulse-logo.png'),
        link: 'https://tgpulse.com',
        ...this.configProductSettings?.[ProductNames.TGPULSE] ?? {}
      },
      {
        product: ProductNames.Modero,
        title: 'Modero',
        description: this.$t('our_products_description_modero').toString(),
        logo: require('../../../../assets/product-logos/easymoder.png'),
        link: tgLoginLink('modero'),
        ...this.configProductSettings?.[ProductNames.Modero] ?? {}
      },
      {
        product: ProductNames.ADSTORYBOT,
        title: 'AdStoryBot',
        description: this.$t('our_products_description_adstorybot').toString(),
        logo: require('../../../../assets/product-logos/addStory.png'),
        link: tgLoginLink('adstorybot'),
        ...this.configProductSettings?.[ProductNames.ADSTORYBOT] ?? {}
      },
      {
        product: ProductNames.TGSCOUTBOT,
        title: 'TgScoutBot',
        description: this.$t('our_products_description_tgscoutbot').toString(),
        logo: require('../../../../assets/product-logos/tgScout.png'),
        link: tgLoginLink('tgscoutbot'),
        ...this.configProductSettings?.[ProductNames.TGSCOUTBOT] ?? {}
      },
    ]
  }

  get productsToExclude(): Array<ProductNames> | undefined {
    return this.$store.state.AdminTemplate.applicationConfig.footer.ourProducts?.exclude
  }

  get productsToShow(): Array<CompanyProduct> {
    const exclude = this.productsToExclude

    if (exclude !== undefined) {
      return this.products.filter(product => !exclude.includes(product.product))
    }

    return this.products
  }

  get productsTitle() {
    return this.title ? this.title : this.$t('our_products_title').toString()
  }
}
